const style = {
  buttonWrapper: { vertical: 'small' },
}

export default style
